import React from "react";
import "./Components.scss";
import "./main.scss";
import { Box } from '@mui/material';

const Slogan = ({ text }) => {

	return (
		<Box sx={{ textAlign: "center", fontFamily: "Josefin Sans", fontSize: "3rem", fontStyle: "italic", mt: 3, color: "#454141" }}>
			<h4 className="dressDisplay-description__head">
				{text}
			</h4>
		</Box >
	);
};

export default Slogan;
